import { FieldValidator } from './FieldValidator';
import { FormValidator } from './FormValidator';

const Validator = {
  Form: FormValidator,
  Field: FieldValidator,
};

export default Validator;
